import axios, { AxiosStatic } from "axios";
import { createApi, IApi } from "./api";
import { interceptError, interceptSuccess } from "./api/interceptors";
import { config, IConfig } from "./config";

axios.interceptors.response.use(interceptSuccess as any, interceptError as any);

export const axiosDependencies: AxiosStatic = axios;

const saltcomplianceApiRoot = config.saltcomplianceApiRoot ? config.saltcomplianceApiRoot : "";

export const api = createApi({
  axios: axiosDependencies,
  saltcomplianceApiRoot,
});

export interface IStorageKeys {
  accountId: string;
  organizationId: string;
  root: string;
  version: string;
  courseAmount: string;
  classAmount: string;
  exportedScormPackagesAmount: string;
  groupsAmount: string;
  usersAmount: string;
  fetchTimestamp: string;
}

export interface IDependencies extends IConfig {
  api: IApi;
  saltcomplianceLocalStorageKeys: IStorageKeys;
  window: Window;
}

export const dependencies: IDependencies = {
  ...config,
  api,
  saltcomplianceLocalStorageKeys: {
    accountId: "SALTCOMPLIANCE/accountId",
    classAmount: "SALTCOMPLIANCE/classAmount",
    courseAmount: "SALTCOMPLIANCE/courseAmount",
    exportedScormPackagesAmount: "SALTCOMPLIANCE/exportedScormPackagesAmount",
    fetchTimestamp: "SALTCOMPLIANCE/fetchTimestamp",
    groupsAmount: "SALTCOMPLIANCE/groupsAmount",
    organizationId: "SALTCOMPLIANCE/organizationId",
    root: "SALTCOMPLIANCE/root",
    usersAmount: "SALTCOMPLIANCE/usersAmount",
    version: "SALTCOMPLIANCE/version",
  },
  window,
};
